import axios from 'axios'

export const getEvents = async(text) => {
    let data;
    await axios.get(`${process.env.REACT_APP_API_HOST}/events/`).then(resp => {
        data = resp.data;
    });
    return data;
}